import type { LabAcquisitionOffer } from '@/lib/api/labAcquisitionHooks';
import type { CartPromotionQuote } from '@/features/marketplace/cartPromotion';

export interface StackSelection { sanityId: string; frequency: 'monthly' | 'quarterly' }
export interface StackPurchase {
  sourcePurchasedAt: string;
  selections: StackSelection[];
  completed: string[];
  requestId: string;
  paymentMethodId: string;
  labOffer: LabAcquisitionOffer;
  quote: CartPromotionQuote | null;
}
const key = (owner: string, source: string) => `system.upsell.stack.${owner}.${source}.v1`;
export function readStackPurchase(owner: string | undefined, source: string, purchasedAt: string): StackPurchase | null {
  if (!owner) return null;
  try {
    const saved = JSON.parse(localStorage.getItem(key(owner, source)) || 'null');
    return saved?.sourcePurchasedAt === purchasedAt && saved?.requestId && saved.paymentMethodId && saved.labOffer?.acquisition_id &&
      Array.isArray(saved.selections) && Array.isArray(saved.completed) ? saved : null;
  } catch { return null; }
}
export function saveStackPurchase(owner: string, source: string, saved: StackPurchase | null) {
  if (saved) localStorage.setItem(key(owner, source), JSON.stringify(saved));
  else localStorage.removeItem(key(owner, source));
}
